import * as React from "react";
import ModalRegistrazione from "@src/components/frontend/modals/ModalRegistrazione";
import FormRadio from "@src/components/ui/FormRadio";
import FormInput from "@src/components/ui/FormInput";
import FormDate from "@src/components/ui/FormDate";
import * as moment from "moment";

interface Props {
    header: string,
    onSave?: any,
    onEdit?: any,
    onCancel?: any,
    esperienza?: any,
}

interface State {
    _modal_esperienza_materia: string,
    _modal_esperienza_descrizione: string,
    _modal_esperienza_start_date: any,
    _modal_esperienza_end_date: any,
    isEdit: any,
}

export default class ModalEsperienza extends React.Component<Props, State> {
    constructor(props) {
        super(props)

        console.log('constructor', this.props);

        if(this.props.esperienza !== undefined && this.props.esperienza !== null) {
            this.state = {
                _modal_esperienza_materia: this.props.esperienza.name,
                _modal_esperienza_descrizione: this.props.esperienza.descr,
                _modal_esperienza_start_date: this.props.esperienza.from,
                _modal_esperienza_end_date: this.props.esperienza.to,
                isEdit: true,
            }
        } else {
            this.state = {
                _modal_esperienza_materia: "",
                _modal_esperienza_descrizione: "",
                _modal_esperienza_start_date: null,
                _modal_esperienza_end_date: null,
                isEdit: false,
            }
        }
    }

    handleChange(field, value) {
        this.setState({
            [field]: value
        });
    }

    onSave() {
        let result = {
            name: this.state._modal_esperienza_materia,
            descr: this.state._modal_esperienza_descrizione,
            from: this.state._modal_esperienza_start_date,
            to: this.state._modal_esperienza_end_date,
        };

        if(result.name === undefined || result.name === '' || result.descr === undefined || result.descr === '') {
            alert('Inserire correttamente materia e descrizione.');
            return;
        }

        console.log(result.from);
        console.log(result.to);
        console.log(moment(result.from));
        console.log(moment(result.to));
        console.log(moment(result.from) < moment(result.to));

        if(result.from != null && result.to != null) {
            if(! (moment(result.from) < moment(result.to))) {
                alert('Compilare correttamente data di inizio e fine esperienza.');
                return;
            }
        }

        if(result.from == null) {
            alert('Compilare correttamente data di inizio esperienza.');
            return;
        }

        if(this.state.isEdit === false) {
            console.log('onSave');
            if(this.props.onSave)
                this.props.onSave(result);
        } else {
            console.log('onEdit');

            result.key = this.props.esperienza.key;
            if(this.props.onEdit)
                this.props.onEdit(result);
        }

    }

    render() {
        let items = [
            {
                key: "triennale",
                value: "Laurea triennale"
            },
            {
                key: "specialistica",
                value: "Laurea specialistica"
            },
            {
                key: "master",
                value: "Master"
            },
            {
                key: "altro",
                value: "Altro"
            }
        ];

        return (
            <ModalRegistrazione header={this.props.header} onSave={this.onSave.bind(this)} onCancel={this.props.onCancel}>
                <div className={"block-qa"}>
                    <span>Esperienze lavorative</span>
                    <div className={"row"} style={{ marginTop: "20px" }}>
                        <div className={"col-xs-6"}>
                            <FormInput type={"text"} placeholder={"Titolo esperienza"} required name="_modal_esperienza_materia" value={this.state._modal_esperienza_materia} onChange={this.handleChange.bind(this)} />
                        </div>
                        <div className={"col-xs-12"}>
                            <FormInput type={"textarea"} height={"240px"} style={{ fontSize: '12px' }} placeholder={"Descrizione dell'esperienza"} required name="_modal_esperienza_descrizione" value={this.state._modal_esperienza_descrizione} onChange={this.handleChange.bind(this)} />
                        </div>
                        <div className={"col-xs-6"}>
                            <FormDate format={['mm', 'yyyy']} label={"Specificare data inizio esperienza"} required name="_modal_esperienza_start_date" value={this.state._modal_esperienza_start_date} onChange={this.handleChange.bind(this)} />
                        </div>
                        <div className={"col-xs-6"}>
                            <FormDate format={['mm', 'yyyy']} label={"Specificare data fine esperienza"} required name="_modal_esperienza_end_date" value={this.state._modal_esperienza_end_date} onChange={this.handleChange.bind(this)} />
                        </div>
                    </div>
                </div>
            </ModalRegistrazione>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/modals/ModalEsperienza.tsx